import { API_AUTH } from "./common";

const GuiEmailApi = {
  guiEmail: ({
    EmailNguoiNhan,
    TenNguoiNhan,
    TieuDe,
    NoiDung,
    ChoVayID,
    Type,
  }) =>
    API_AUTH.post(`he-thong/gui-email-hop-dong`, {
      EmailNguoiNhan,
      TenNguoiNhan,
      TieuDe,
      NoiDung,
      ChoVayID,
      Type,
    }),
};

export default GuiEmailApi;
